import { Skeleton } from '@bbl-digital/snorre'
import { getAddressFilterValues } from 'Modules/HousingAssociation/OurCompany/shared/helpers/addressPicker-helper'
import { IClientAddress } from 'Modules/HousingAssociation/OurCompany/shared/models/Unit'
import { Fragment } from 'react'
import DropdownFilter from 'shared/components/DropdownFilter'
import { DropdownWrapper } from './styles'

interface IProps {
  onChangeAddress: (value: number | null) => void
  selected: number | null
  data: IClientAddress[]
  loading: boolean
  error: string
}

const AddressPicker: React.FC<IProps> = ({
  onChangeAddress,
  selected,
  data,
  loading,
  error,
}) => {
  if (!loading && data?.length <= 1 && !error) return null

  return (
    <DropdownWrapper className="units-addresses-btn">
      {error && <Fragment>Feil under uthenting av adresser</Fragment>}
      {loading && (
        <Skeleton height="38px" width="141px" borderRadius="19px" rectangle />
      )}
      {!loading && data && data.length > 1 && (
        <DropdownFilter
          advancedValues={getAddressFilterValues(data)}
          onChange={(e) => onChangeAddress(e as number | null)}
          value={selected || undefined}
        />
      )}
    </DropdownWrapper>
  )
}

export default AddressPicker
